<template>
	<v-dialog v-model="dialog" persistent max-width="400" scrollable>
		<v-card>
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-14 cl-secondary">Pencarian Data</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-col class="px-0 cl-secondary font-size-11 font-weight-500 border-grey">
					<v-row>
						<v-col cols="12">
							<v-menu v-model="searchDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field hide-details label="Tanggal" prepend-icon="mdi-calendar-search" readonly v-bind="attrs" v-on="on" :value="convertDate(filterDate)"></v-text-field>
								</template>
								<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="searchDate = false" v-model="filterDate"></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12">
							<v-text-field hide-details label="Nama Penerima" prepend-icon="mdi-account-arrow-left" color="primary" v-model="params.name.value"></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field hide-details label="Kode Mitra Penerima" prepend-icon="mdi-account-arrow-left-outline" color="primary" v-model="params.code.value"></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field hide-details label="Nama Pengirim" prepend-icon="mdi-account-arrow-right" color="primary" v-model="params.namesender.value"></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field hide-details label="Kode Mitra Pengirim" prepend-icon="mdi-account-arrow-right-outline" color="primary" v-model="params.codesender.value"></v-text-field>
						</v-col>
						<v-col cols="12" v-if="false">
							<v-menu v-model="startDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field hide-details label="Dari Tanggal" readonly v-bind="attrs" v-on="on" :value="convertDate(dateStart)"></v-text-field>
								</template>
								<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="startDate = false" v-model="dateStart"></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12" v-if="false">
							<v-menu v-model="endDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field hide-details label="Dari Tanggal" readonly v-bind="attrs" v-on="on" :value="convertDate(dateEnd)"></v-text-field>
								</template>
								<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="endDate = false" v-model="dateEnd"></v-date-picker>
							</v-menu>
						</v-col>
					</v-row>
				</v-col>
			</v-card-text>
			<v-card-actions class="justify-center">
				<v-col cols="4">
					<v-btn depressed block color="primary" class="white--text rounded-lg text-capitalize" :loading="btnLoadingProses" :disabled="btnLoadingProses" @click="cari">
						<v-icon small v-if="false">mdi-magnify</v-icon>
						<span>Cari</span>
					</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

export default {
	data () {
		return {
			dialog: false,
			startDate: false,
			endDate: false,
			dateStart: new Date().toISOString().slice(0, 10),
			dateEnd: new Date().toISOString().slice(0, 10),
			searchDate: false,
			filterDate: null,
			btnLoadingProses: false,
			params: {
				name: {
					type:'string',
					field:'ewallet_product_transfer_receiver_member_name',
					comparison: '=',
					value:''
				},
				code: {
					type:'string',
					field:'ewallet_product_transfer_receiver_network_code',
					comparison: '=',
					value:''
				},
				namesender: {
					type:'string',
					field:'ewallet_product_transfer_sender_member_name',
					comparison: '=',
					value:''
				},
				codesender: {
					type:'string',
					field:'ewallet_product_transfer_sender_network_code',
					comparison: '=',
					value:''
				},
				date: {
					type:'date',
					field:'ewallet_product_transfer_datetime',
					comparison: 'bet',
					value:''
				},
			},
		}
	},
	computed:{

	},
	watch: {
		// eslint-disable-next-line no-unused-vars
		filterDate: function (newDate, pastDate) {
			this.params.date.value = newDate + '::' + newDate
    }
	},
	methods :{
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
			this.btnLoadingProses = false
		},
		reset() {
			this.params.name.value = ''
			this.params.code.value = ''
			this.params.namesender.value = ''
			this.params.codesender.value = ''
			this.params.date.value = ''
		},
		async cari() {
			if ( this.params.name.value || this.params.code.value || this.params.namesender.value || this.params.codesender.value || this.params.date.value ) {
				// if (this.params.date.value) this.params.date.value = await this.params.date.value + '::' + this.params.date.value
				this.btnLoadingProses = await true
				this.$emit('action', this.params)
			}
		},
	}
};
</script>